enum RemunerationType {
  SALARIED = 'Salaried',
  HOURLY = 'Hourly',
  COMMISSIONED = 'Commissioned',
}
export default RemunerationType
